module.exports = __webpack_public_path__ + "img/founder.a62282a1.jpg";